import { render } from "./notify-popup.vue?vue&type=template&id=a2dee7ec&ts=true"
import script from "./notify-popup.vue?vue&type=script&lang=ts"
export * from "./notify-popup.vue?vue&type=script&lang=ts"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__